"use client";

import { IconAlertTriangle } from "@tabler/icons-react";
import { toast } from "sonner";
import { ConfirmDialog } from "@/components/confirm-dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function OrganizationsDeleteAllDialog({
  open,
  onOpenChange,
}: Readonly<Props>) {
  const handleDeleteAll = () => {
    onOpenChange(false);
    toast(
      "You would integrate an API call to delete all or selected rows here.",
      {
        description: "All organizations have been deleted (mock).",
      },
    );
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      handleConfirm={handleDeleteAll}
      title={
        <span className="text-destructive flex items-center gap-1">
          <IconAlertTriangle
            className="stroke-destructive inline-block"
            size={18}
          />
          Delete All Organizations
        </span>
      }
      desc={
        <div className="space-y-4">
          <p>
            Are you sure you want to delete all organizations? This action
            cannot be undone.
          </p>
        </div>
      }
      confirmText="Delete"
      destructive
    />
  );
}
